import { render, staticRenderFns } from "./TabsManagement.vue?vue&type=template&id=92a5d58c&lang=pug"
import script from "./TabsManagement.vue?vue&type=script&lang=js"
export * from "./TabsManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports